import React from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'react-bootstrap-icons';

import styles from './MedicoStatus.module.css';

export const MedicoStatus = ({ email, validado, activo, steps = [] }) => {
  // Esperamos 5 elementos (steps): punto, línea, punto, línea, punto
  // Esperamos 6 elementos (data): icono, texto, icono, texto, icono, texto
  return (
    <>
    <div className="row mb-3">
        <div className={"col " + styles.dataContainerL}>
            <div className={styles.dataContainer}>
                <div className='me-2'>
                  {(email)
                  ? <Icon.Check color='#7FAE1B' size={28} />
                  : <Icon.X color='#6C757D' size={28} />
                  }
                </div>
                <div style={{color: (email) ? '#000000' : '#6C757D'}}>
                    <div className={styles.resumenText}>Correo</div>
                    <div className={styles.resumenText}>{(email) ? 'Verificado' : 'No verificado'}</div>
                </div>
            </div>
        </div>
        <div className={"col " + styles.dataContainerC}>
            <div className={styles.dataContainer}>
                <div className='me-2'>
                  {(validado)
                  ? <Icon.Check color='#7FAE1B' size={28} />
                  : <Icon.X color='#6C757D' size={28} />
                  }
                </div>
                <div style={{color: (validado) ? '#000000' : '#6C757D'}}>
                    <div className={styles.resumenText}>Documentos</div>
                    <div className={styles.resumenText}>{(validado) ? 'Verificados' : 'No verificados'}</div>
                </div>
            </div>
        </div>
        <div className={"col " + styles.dataContainerR}>
            <div className={styles.dataContainer}>
                <div className='me-2'>
                  {(activo)
                  ? <Icon.Check color='#7FAE1B' size={28} />
                  : <Icon.X color='#6C757D' size={28} />
                  }
                </div>
                <div style={{color: (activo) ? '#000000' : '#6C757D'}}>
                    <div className={styles.resumenText}>Status</div>
                    <div className={styles.resumenText}>{(activo) ? 'activo' : 'inactivo'}</div>
                </div>
            </div>
        </div>
    </div>
    <div className={styles.container}>
      {[0, 2, 4].map((i, idx) => (
        <React.Fragment key={`step-${i}`}>
          <div
            className={styles.circle}
            style={{
              backgroundColor: steps[i]?.color || '#ccc',
            }}
          />
          {i < 4 && (
            <div
              className={styles.line}
              style={{
                backgroundColor: steps[i + 1]?.color || '#ccc',
              }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
    </>
  );
};

MedicoStatus.propTypes = {
    email: PropTypes.bool.isRequired,
    validado: PropTypes.bool.isRequired,
    activo: PropTypes.bool.isRequired,
}